
import {AuthService} from '../services';

export default {
    requestHandler(request) {
        return request;
    },
    errorHandler(error) {
        if (error?.response?.status === 401 && localStorage['authToken']) {
            AuthService.signOut();
            window.location.href = '/login';
            return {};
        }
        return Promise.reject(error);
    },
    successHandler(response) {
        return response;
    }
};
